import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import { Client as Styletron } from 'styletron-engine-atomic'
import { Provider as StyletronProvider } from 'styletron-react'
import { BaseProvider, styled } from 'baseui'
import { Button } from 'baseui/button'
import ContextProvider from '~/provider/ContextProvider'
import { GlobalStyle } from '~/utils/styles'
import Navigation from '~/components/Navigation'

import theme from '~/config/theme'
import { DESKTOP } from '../utils/styles'

const Layout = ({ children, pageContext }) => {
  const [engine, setEngine] = useState(null)

  useEffect(() => {
    // Load the `styletron-engine-atomic` package dynamically.
    // Reason: It requires use of `document`, which is not available
    // outside the browser, so we need to wait until it successfully loads.
    // Source: https://www.gatsbyjs.org/docs/debugging-html-builds/
    import('styletron-engine-atomic').then(styletron => {
      const clientEngine = new styletron.Client()
      setEngine(clientEngine)
    })
  }, [])

  if (!engine) return null

  return (
    <StyletronProvider value={engine}>
      <BaseProvider theme={theme}>
        <ContextProvider>
          <GlobalStyle />
          <StaticQuery
            query={graphql`
              query SiteTitleQuery {
                site {
                  siteMetadata {
                    title
                  }
                }
              }
            `}
            render={data => (
              <Wrapper $layout={pageContext.layout}>
                <Navigation
                  siteTitle={data.site.siteMetadata.title}
                  layout={pageContext.layout}
                />
                {children}
              </Wrapper>
            )}
          />
        </ContextProvider>
      </BaseProvider>
    </StyletronProvider>
  )
}

const Wrapper = styled('div', props => {
  return {
    height: props.$layout === 'step' ? 'calc(100vh - 89px)' : '100%',
    overflowY: 'scroll',
    [DESKTOP]: {
      height: '100%',
    },
  }
})

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
